import * as React from "react";
import { DashboardFileTable } from "@/components/feature/tables/dashboard_cards/DashboardFileTable";
import { TxType } from "@/types/transaction";
import { useGetTransactionsQuery } from "@/api/transactions";
import { FileItem } from "@/views/home/upload/uploadMocks";

export const DashboardRecentUploads: React.FC = () => {
  const { data = [] } = useGetTransactionsQuery({ perPage: 5, txType: TxType.UPLOAD });

  const filesWithStatus = data.flatMap(curr =>
    curr.file_progresses.map(row => ({
      uploadDate: curr.created_at,
      name: row.fse_name,
      status: row.progress >= 1 ? "processed" : "processing",
      progress: row.progress,
      type: row.fse_name.endsWith(".pdf") ? "pdf file" : "doc file",
      id: row.fse_id,
      size: 0,
    })),
  ) as FileItem[];

  return (
    <>
      <DashboardFileTable files={filesWithStatus} limit={5} />
    </>
  );
};
